import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchComponent } from '@enginuity/core/molecules/search/search.component';
import { DropdownSinglePieceComponent } from '@enginuity/core/molecules/dropdown-single-piece/dropdown-single-piece.component';
import { TableViewHeader } from '@services/ui-services/models';
@Component({
  selector: 'app-table-property',
  templateUrl: './table-property.component.html',
  styleUrls: ['./table-property.component.scss'],
  imports: [CommonModule, SearchComponent, DropdownSinglePieceComponent],
})
export class TablePropertyComponent implements OnInit, OnDestroy {
  @Output() custom_click = new EventEmitter<object>();
  @Output() onChange = new EventEmitter<any>();
  @Input()
  item_name = 'Date';

  @Input()
  search = true;

  @Input()
  dropdown: any = [
    { label: 'Price', icon: 'balance', isShow: true },
    { label: 'Quote type', icon: 'change_circle', isShow: true },
    { label: 'Qty', icon: 'jam_hashtag', isShow: true },
    { label: 'Channel', icon: 'filter', isShow: true },
    { label: 'Joined date', icon: 'calendar', isShow: true },
    { label: 'Messages', icon: 'chat', isShow: true },
    { label: 'Shopping items', icon: 'cart', isShow: true },
  ];

  dataList: any = [];
  searchString = '';

  ngOnInit(): void {
    this.dataList = this.getDataList;
  }

  get getDataList() {
    let data;
    if (this.searchString !== '') {
      data = this.dropdown.filter((x: any) =>
        x.label.toLowerCase().includes(this.searchString.toLowerCase())
      );
    } else {
      data = this.dropdown.filter((x: any) => x.label !== '');
    }
    return data.sort((a: any, b: any) => b.isShow - a.isShow);
  }

  onSearch(searchedString: any) {
    this.searchString = searchedString;
    this.dataList = this.getDataList;
  }

  onClearAll() {
    this.searchString = '';
    this.dataList = this.getDataList;
  }

  handlePropertyChange(row: TableViewHeader) {
    row.isShow = !row.isShow;
    this.onChange.emit(row);
  }

  ngOnDestroy(): void {
    this.custom_click.emit({ action: 'save-table-header' });
  }
}
